import React, { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import CircleIcon from '@mui/icons-material/Circle';
import { styled, Typography } from '@mui/material';

const StyledIconWrapper = styled('div')(() => ({
  position: 'relative'
}));

const StyledDiv = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(-2),
  top: theme.spacing(-2)
}));

interface Props {
  isCompleted: boolean;
  label: string;
  isInvalid: boolean;
  hideCircle?: boolean;
}
const TabCustomLabel: FC<Props> = ({ isCompleted, isInvalid, label, hideCircle }) => {
  const theme = useTheme();

  return (
    <>
      <Typography variant="subtitle1" component="span">
        {label}
      </Typography>
      <StyledIconWrapper>
        <StyledDiv>
          {(isCompleted || isInvalid) && !hideCircle && (
            <CircleIcon
              sx={{
                fontSize: 10,
                color: isInvalid ? theme.palette.warning.main : theme.palette.success.main
              }}
            />
          )}
        </StyledDiv>
      </StyledIconWrapper>
    </>
  );
};

export default TabCustomLabel;
